const CONNECT_UI_IFRAME_ID = 'connect-ui';

let connectUIOpenCount = 0;
let connectUIIframeWasVisible = false;
let listenersInstalled = false;

const isConnectUIVisible = () =>
  Boolean(document.getElementById(CONNECT_UI_IFRAME_ID));

const reconcileConnectUIOpenCount = () => {
  if (isConnectUIVisible()) {
    connectUIIframeWasVisible = true;
    return;
  }

  if (connectUIIframeWasVisible && connectUIOpenCount > 0) {
    connectUIOpenCount = 0;
    connectUIIframeWasVisible = false;
  }
};

export const shouldBypassModalFocusLockForConnectUI = () => {
  reconcileConnectUIOpenCount();
  return connectUIOpenCount > 0 || isConnectUIVisible();
};

const blockModalFocusLockHandler = (event: Event) => {
  if (shouldBypassModalFocusLockForConnectUI()) {
    event.stopImmediatePropagation();
  }
};

/**
 * Nango Connect UI renders a full-screen iframe on `document.body`. Arc's
 * ModalV2 (@reach/dialog) traps focus with crossFrame enabled, which pulls
 * focus back into the parent modal and makes the Connect UI inputs unusable.
 *
 * Listeners are registered once at app startup so they run before react-focus-lock
 * attaches when the first modal opens. They are intentionally never removed —
 * this runs once for the lifetime of the app (called from main.tsx, not a
 * component effect), and the handler is a no-op whenever Connect UI isn't open.
 */
export const installModalFocusLockBypassForConnectUI = () => {
  if (listenersInstalled) {
    return;
  }

  document.addEventListener('focusin', blockModalFocusLockHandler, true);
  document.addEventListener('focusout', blockModalFocusLockHandler, true);
  window.addEventListener('blur', blockModalFocusLockHandler, true);
  listenersInstalled = true;
};

export const markConnectUIOpen = () => {
  connectUIOpenCount = 1;
  connectUIIframeWasVisible = false;
};

export const markConnectUIClosed = () => {
  connectUIOpenCount = 0;
  connectUIIframeWasVisible = false;
};

/** @visibleForTesting */
export const resetConnectUIOpenCountForTests = () => {
  connectUIOpenCount = 0;
  connectUIIframeWasVisible = false;
};
